import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 获取商品标签信息数据列表（#191）
 */
export function getLabelList() {
  return request("".concat(BASE_URL) + "/product/label/list", METHOD.GET);
}

/** 新增商品标签信息数据（#192）
 * @param {Object} data
 */
export function addLabel(data) {
  return request("".concat(BASE_URL) + "/product/label", METHOD.POST, data);
}

/**
 * 获取标签详情数据（#193）
 */
export function getLabelDetail(id) {
  return request("".concat(BASE_URL) + "/product/label/detail/" + id, METHOD.GET);
}

/** 编辑商品标签状态数据（#195）
 * @param {Object} data
 */
export function updateLabelStatus(data) {
  return request("".concat(BASE_URL) + "/product/label/status", METHOD.PUT, data);
}

/** 删除商品标签数据（#196）
 * @param {Object} data
 */
export function deleteLabel(id) {
  return request("".concat(BASE_URL) + "/product/label/" + id, METHOD.DELETE);
}

/** 编辑商品标签信息数据（#194）
 * @param {Object} data
 */
export function updateLabel(data) {
  return request("".concat(BASE_URL) + "/product/label", METHOD.PUT, data);
}

/**
 * 获取发货渠道id及name数据列表（#122）
 */
export function getMerchantChannelList(data) {
  return request("".concat(BASE_URL) + "/merchantChannel/onlyIdAndName/list", METHOD.GET, data);
}